import BackgroundGeolocation from 'cordova-background-geolocation';
import { isFinite, uniqWith } from 'lodash';
import { minutesToMilliseconds, secondsToMilliseconds } from '../../util/time';
import { isPlatform } from '@ionic/core';

export const GEO_DEBUG = process.env.REACT_APP_ENV === 'geo_debug';

// According to transistorsoft/cordova-background-geolocation-lt#541 (comment)
// If you were to set geofenceProximityRadius: 75, you'd completely break geofencing. The minimum reliable radius for a geofence is 150 meters.
// I think this may be in relation to driving, though, because a comment above that from Chris Scott says:
// This is to prevent you from shooting yourself in the foot, driving through geofences before the plugin had a chance to activate them.
// It's not necessary to have a lower geofenceProximityRadius. Why do you think you'd want that?
export const geolocationConfig = !(isPlatform('android') || isPlatform('ios'))
  ? {}
  : {
      reset: true, // Init with a new config

      // Application config
      pausesLocationUpdatesAutomatically: false,
      stopOnTerminate: false,
      startOnBoot: true,

      // Geolocation Config
      geofenceProximityRadius: 100, // Meters
      desiredAccuracy: 0, // Highest
      geofenceInitialTriggerEntry: true, // Trigger immediately if device already inside
      distanceFilter: 10,

      // [Android]
      enableHeadless: true,
      forceReloadOnBoot: true,
      notificationText: 'Location Services are running',

      // Activity Recognition
      activityRecognitionInterval: secondsToMilliseconds(10),
      minimumActivityRecognitionConfidence: 75,
      stopTimeout: 5, // Minutes

      // Debug
      debug: false, // Enable this to hear sounds for events
      logLevel: BackgroundGeolocation.LOG_LEVEL_OFF, // LOG_LEVEL_VERBOSE / LOG_LEVEL_OFF // This breaks web app without platform check
    };

const GEOFENCE_DEFAULTS = {
  radius: 50,
  notifyOnEntry: GEO_DEBUG ? true : false,
  notifyOnExit: false,
  notifyOnDwell: true,
};

export const toGeofence = ({
  extras,
  identifier,
  idleTime,
  latitude,
  longitude,
}) => ({
  ...GEOFENCE_DEFAULTS,
  identifier,
  latitude,
  longitude,
  loiteringDelay: minutesToMilliseconds(idleTime),
  extras,
});

export const hasCoords = obj => {
  const { latitude, longitude } = obj;
  return isFinite(latitude) && isFinite(longitude);
};

export const getUniqueLocations = locations => {
  GEO_DEBUG && console.log('LOCATIONS: ', locations);
  return uniqWith(
    locations,
    (locationA, locationB) =>
      locationA.latitude === locationB.latitude &&
      locationA.longitude === locationB.longitude,
  );
};



// WEBPACK FOOTER //
// ./src/modules/Geolocation/util.js